/**
 * The app's version as the owner counts it — „ვერსია 1.9" in the sidebar
 * footer and the phone's „მეტი" sheet.
 *
 * The owner, 2026-09-30: „ვერსია 30.09 19:52 ძალიან ცუდად ჟღერს, მოდი ვერსია
 * 1.8-ად აღვიქვათ (live `d695d809`), და შემდეგი განახლება იყოს ვერსია 1.9".
 *
 * ⚠️ ONE step per release: raise this by 0.1 before the preview of the next
 * release is uploaded (several uploads of one release keep the same number).
 * The minute the bundle was built stays available as a tooltip
 * (`process.env.NEXT_PUBLIC_BUILD_AT`, vite.config.ts) for support.
 */
// 1.9 = live `8e22d046` (2026-10-01). The owner the same day: the next is
// „1.10", not „2.0". 1.10 = live `a2375613` (2026-10-01).
// 1.11 = the chain's FINA replacement work (IMEI + warranty, 128 …).
// 1.15 = the on-screen keyboard for a touch-screen till (2026-10-02, GIOSHOP).
// 1.16 = the shop's business day (a night shop's night is one day), the big
// closing screen and the cart's photos sized to the room (2026-10-03, SAMGORI).
// 1.17 = a shop without ნისია closes a shift without two ₾0.00 ნისია rows.
// 1.18 = the cashier's daily salary paid at close (137), the expense form's business-day default.
// 1.21 = the optional Cherry (light), Dark Cherry and Amethyst appearance palettes (2026-10-04).
// 1.22 = the safety pack, built with Codex: a return is never a replay (141), the
// opening stock asks after sales (142), the product cache knows the shop, the
// nightly backup is checked every morning (2026-10-04).
// 1.23 = the newer surface audited twice (143 salary once a day, 144 real replay prices,
// 145 repairs in the support log, Telegram private-only) and the truth pack (2026-10-05).
// 1.24 = the till does not wait for the history: a two-phase boot, with Codex (2026-10-05).
// 1.27 = accounting's top figures do not wait for the history: the database sums
// the past (148), the device's rows the rest — built with Codex (2026-10-05).
// 1.28 = the shop runs its website from the till — online orders, the site's
// settings, the „საიტზე" switch (151–154; the store itself is not public yet) —
// and the close dialog's count stays in sight above a keyboard (2026-10-07).
// 1.32 = a new online order chimes, says so and lights the menu wherever the till is (2026-10-10,
// the owner); ships with the online store's release B (the store Worker).
// 1.33 = for clothing and sneaker shops: the new-model dialog is one colours × sizes table
// (one screen at 1920), one category picker, sub-category chips and 6 cards at the till,
// a wholesale price that can be cleared, and მარჟა as the one profit percent (2026-10-10).
// 1.35 = no hidden colour at the till, four short Settings groups, and the
// new-model dialog's three visible work zones (2026-10-10).
// 1.38 = the card's bank is picked in the sale confirmation on big touch tiles
// (the device's last bank preselected, 1/2/3 + Enter; the exchange too) and the
// soft grey-blue „ნისლი" light palette (2026-10-12).
// 1.39 = a small till screen (a 4:3 Posiflex at 1024×768) starts with the menu
// folded, ≡ opens it over the page, and the bank tiles lose their „1 2 3" (2026-10-12).
// 1.40 = several barcodes per product (Lilu's FINA cells „A / B" and „PLU 24"): scanned
// anywhere, attached at the till by the owner, split by the Excel import (2026-10-13).
// 1.44 = the cart's quantity is typed (eggs by the dozen), the import names the exact Excel
// row of a refused code, and the server keeps extra codes whole (160) (2026-10-15).
// 1.45 = the phone's cart closes once a sale's receipt is closed, and a shop's help request
// reaches the platform admin — a chime and a count in the app, a Telegram message (161) (2026-10-15).
// 1.46 = staff in three tabs (მოლარეები · ანგარიშები · ცვლები), the platform console's
// clickable KPIs and phone tools sheet, and the owner's zip holds every business table (2026-10-16).
// 1.47 = „სიმტკიცე": Codex's strict audit of 1.46, checked and fixed (163-165) (2026-10-16).
// 1.48 = „მცველი": the platform console asks for the phone's code, on its own login; a shop can
// no longer be deleted from the app (166, 167) (2026-10-16).
// 1.52 = the till reads a scale on a cable: text tiles with the money for the live weight, one
// press adds the scale's fresh weight when the zero rule allows (2026-10-17; LIVE waits for a real scale).
// 1.53 = a supplier's payment clears its purchases' debt; „ხურდის თეთრები“ (168) (2026-10-18).
// 1.54 = return to supplier (170), a product can be a service (169), the receiving dialogs ask
// where the paid money came from (171), strict audit 2's fixes (2026-10-18).
// 1.55 = „დაშლა" from one product into many — a carcass into its cuts, a set into its pieces,
// the cost split by sale value (172); first-day suggestions for seven templates (2026-10-18).
// 1.56 = the customer display: the shop's storefront when idle, the cart across the screen,
// and the buyer's own receipt — the model the printer prints from — feeding out of a
// printer after the sale; the MartePOS mark by Codex (2026-10-19).
// 1.59 = a drink takes its cup: what a product or a category includes in its price, taken by the
// server with every unit sold at ₾0 and its own cost (182) (2026-10-21).
// 1.64 = the change chips only when the change is not whole 5 tetri — what the till can
// hand in coins needs no chip (2026-10-27).
// 1.65 = the need record (the till writes what a buyer asked for and the shop lacked) and the supplier order
// („შესაძენი" and the needs as a saved order per supplier, received through the purchase window) (191, 2026-10-27).
// 1.67 = the waiter's phone (/waiter) and the kitchen screen (/kitchen): ready reaches the waiter (in the app and by
// Web Push), each dish served on the table; the till still takes the money (193, 2026-11-01).
// 1.68 = the waiter-paid restaurant: the table service as the shop's own service product, the waiter's check printing
// itself at the till (table_check_prints, a scannable code), the till as the bar, photo tables, a paid table stays
// seated until freed, each waiter's numbers (196, 2026-11-02).
// 1.69 = the guests' table QR: call the waiter, ask for the bill, order from a Georgian / English menu on
// menu.martepos.com — confirmed by the waiter before the kitchen (197 visits, 198 requests, 2026-11-03).
// 1.70 = the guest page carries no web app manifest (no „Install" for a guest) and an automatic add-on (a cup, a lid)
// is never on the guests' menu (199); a confirm refused for stale add-on rules re-reads them once (2026-11-03).
// 1.71 = an add-on rule changed on one device reaches every till and phone at once (200), and the QR confirm keeps
// the waiter's quantities after a refusal that changed nothing.
export const APP_VERSION = '1.71'
